// extracted by mini-css-extract-plugin
module.exports = {"swatch":"ColorPicker_swatch__3zkig","swatch__isOpen":"ColorPicker_swatch__isOpen__2nDhq","picker":"ColorPicker_picker__3UbZB","picker_input":"ColorPicker_picker_input__1IRL1"};